import { faArrowRotateLeft, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import MyDialog from 'components/Layout/MyDialog';
import MyIconButton from 'components/Layout/MyIconButton';
import { logError } from 'components/Utils/FormatData';
import { URL_API } from 'utils/globalConfig';
import useAuthz from 'hooks/useAuthz';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';


const ActionsGrillesTarifairesRenderer = (props) => {
  const alert = useAlert();
  const [authz, user, profil] = useAuthz();
  const [content, setContent] = useState('');
  const [dialogData, setDialogData] = useState({ type: '', data: {} });
  const [dialogState, setDialogState] = useState();
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    if (dialogState && dialogData.data) {
      switch (dialogData.type) {
        case 'delete':
          axios({ method: 'post', url: `${URL_API}/grille-tarifaire/delete`, params: { tarifId: dialogData.data, deleted: true, userAction: user.user_id } })
            .then((r) => {
              alert.success('La suppression de la tarification a bien été effectuée avec succés');
              props.setNeedReload(true);
            })
            .catch((error) => {
              logError(alert, error);
            });
          break;
        case 'restore':
          axios({ method: 'post', url: `${URL_API}/grille-tarifaire/delete`, params: { tarifId: dialogData.data, deleted: false, userAction: user.user_id } })
            .then((r) => {
              alert.success('La restauration de la tarification a bien été effectuée avec succés');
              props.setNeedReload(true);
            })
            .catch((error) => {
              logError(alert, error);
            });
          break;
      }

      setDialogState(null);
    }
  }, [dialogState]);

  const deleteGrilleTarifaire = (tarif) => {
    if (tarif != null) {
      setDialogData({ ...dialogData, data: tarif.tarif_id, type: 'delete' });
      setContent(() => {
        return (
          <>
            <div>Êtes-vous sûr de vouloir supprimer la régle de tarif : <b>{tarif.tarif_id + ' - ' + tarif.libelle}</b> ?</div>
          </>
        )
      });
      setOpenDialog(true);
    }
  };

  const restoreGrilleTarifaire = (tarif) => {
    if (tarif != null) {
      setDialogData({ ...dialogData, data: tarif.tarif_id, type: 'restore' });
      setContent(() => {
        return (
          <>
            <div>Êtes-vous sûr de vouloir restaurer la régle de tarif : <b>{tarif.tarif_id + ' - ' + tarif.libelle}</b> ?</div>
          </>
        )
      });
      setOpenDialog(true);
    }
  }

  return (
    <div style={{ width: '100%' }}>
      {
        !props.data.deleted &&
        <MyIconButton
          className='classic-button'
          type='button'
          href='#'
          iconCenter={{ icon: faTrash, type: 'fontAwesome' }}
          styleCss={{ boxShadow: 'none', color: '#0094ca', height: '20px', margin: '5px' }}
          onClick={() => deleteGrilleTarifaire(props.data)}
        />
      }
      {
        props.data.deleted &&
        <MyIconButton
          className='classic-button'
          type='button'
          href='#'
          iconCenter={{ icon: faArrowRotateLeft, type: 'fontAwesome' }}
          styleCss={{ boxShadow: 'none', color: '#0094ca', height: '20px', margin: '5px' }}
          onClick={() => restoreGrilleTarifaire(props.data)}
        />
      }
      <MyIconButton
        lassName='classic-button'
        type='button'
        iconCenter={{ icon: faPen, type: 'fontAwesome' }}
        styleCss={{ boxShadow: 'none', color: '#bb0060', height: '20px', margin: '5px' }}
        href={`/panneau-administration/grille-tarifaire/createOrEdit?id=${props.data.tarif_id}`}
      />

      <MyDialog open={openDialog} handleClose={setOpenDialog} title='Suppression grille tarifaire' content={content} dialog={setDialogState} />
    </div>
  );

};

export default ActionsGrillesTarifairesRenderer;
